import { DateTime } from 'luxon';

export function isSameDay(a: DateTime, b: DateTime) {
  return a.toISODate() === b.toISODate();
}
